<div class="dialog-header" style="padding-left: 20px;">
  <span class="dialog-title" style="text-align: center; flex: 1;">Inhaltsblock hinzufügen</span>
  <mat-icon class="dialog-close" [mat-dialog-close]="null">close</mat-icon>
</div>
<div class="dialog-body">
  <div class="type-grid">
    @for (type of contentTypes; track type.key) {
      <div class="type-card" (click)="selectType(type)">
        <mat-icon class="type-icon">{{ getIcon(type.name) }}</mat-icon>
        <span class="type-label">{{ getLabel(type.name) }}</span>
      </div>
    }
  </div>
</div>
